"use client";

import { c as _c } from "react/compiler-runtime";
import { useSearchSummary } from "@repo/design-system/hooks/use-search-summary";
import { cn } from "@repo/design-system/utils/cn";
import { Button, buttonVariants } from "~/components/ui/button-eon";
import { useLanguage } from "~/translations/loader/use-language";
interface ClearFiltersProps {
  className?: string;
}
export function ClearFilters(t0) {
  const $ = _c(11);
  const {
    className
  } = t0;
  const {
    clearAllFilters
  } = useSearchSummary();
  const t = useLanguage();
  let t1;
  if ($[0] !== className) {
    t1 = cn(buttonVariants({
      variant: "ghost"
    }), className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== clearAllFilters) {
    t2 = async () => await clearAllFilters();
    $[2] = clearAllFilters;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t.filterbar_clearFilters) {
    t3 = <span className="px-2">{t.filterbar_clearFilters}</span>;
    $[4] = t.filterbar_clearFilters;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t.filterbar_titleClear || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <Button className={t1} onClick={t2} title={t.filterbar_titleClear}>{t3}</Button>;
    $[6] = t.filterbar_titleClear;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}